import { render, staticRenderFns } from "./riskDc.vue?vue&type=template&id=03a160c4&scoped=true"
import script from "./riskDc.vue?vue&type=script&lang=js"
export * from "./riskDc.vue?vue&type=script&lang=js"
import style0 from "./riskDc.vue?vue&type=style&index=0&id=03a160c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a160c4",
  null
  
)

export default component.exports